import moment from "moment";
import "moment/locale/es"; // without this line it didn't work

export function stringDateToLocaleString(date: string, locale: string = "es") {
  const newDate = new Date(date.replace(/-/g, "/"));
  moment.locale(locale);
  return moment(newDate).format("LL");
}
